export default {
    en: {
        firstName: 'First Name',
        lastName: 'Last Name',
        middleNameInitial: 'Middle name initial',
        title: 'Title',
        suffix: 'Suffix',
        dateOfBirth: 'Date of Birth',
        phoneNumber: 'Phone number',
        emailAddress: 'Email address',
        addressType: 'Address Type', // Will need address types translated as well
        addressLine1: 'Address Line 1',
        addressLine2: 'Address Line 2',
        addressCity: 'City',
        state: 'State',
        addressZip: 'Zip Code',
        citizenship: 'Citizenship',
        gender: 'Gender',
        maritalStatus: 'Marital Status',
        race: 'Race',
        ethnicity: 'Ethnicity',
        householdGrossMonthlyIncome: 'Househould Gross Monthly Income',
        servicesSeeking: 'What services are you seeking?',
        describeRequest: 'Please describe your request for services',
        pleaseSignPre: 'Please sign in the box below to provide your',
        pleaseSignConsent: 'consent',
        pleaseSignPost: 'to receive services', 
        clearSignature: 'Clear Signature',
        submit: 'SUBMIT',
        submitting: 'Submiting...',
        failedSubmission: 'The form failed to submit. Please submit again.',
        signatureRequired: 'The consent signature is required',
        required: 'Required',
        // military: {
        //     militaryAffiliation: 'Military Affiliation',
        //     currentStatus: 'Current Status',
        //     currentlyTransitioning: 'Currently Transitioning?',
        //     atLeastoneDayActiveDuty: 'Has at least one day of active duty outside of basic training?', //enum
        //     branch: 'Branch of Service', //enum
        //     serviceEra: 'ServiceArea', //enum
        //     entryDate: 'Entry Date',
        //     exitDate: 'Exit Date',
        //     deployed: 'Deployed',
        //     deploymentStartsAt: 'Deployment Dates',
        //     //deploymentEndsAt: ''
        //     //enums
        //     dischargedDueToDisability: 'Discharged or retired from military service for a disability incurred in the line of duty?',
        //     //enum
        //     serviceConnectedDisability: 'Has VA-rated Service-Connected Disability?',
        //     //enum
        //     serviceConnectedDisabilityRating: 'Service-Connected Disability Rating',
        //     //enum
        //     proofOfVeteranStatus: 'Proof of veteran status?',
        //     //enum
        //     proofType: 'Proof Type'
        // },
        consent : {
            title: 'Do',
            consentParagraph1: 'Not',
            consentParagraph2: 'Use',
            consentParagraph3: 'This',
            consentParagraph4: 'Please'
        },
        success: {
            success: 'Success !',
            thankYou: 'Thank you for submitting your request. We are reviewing the request, and look forward to connecting you with the services you need.',
            downloadConsent: 'Download Your Signed Consent Form'
        }


    },
    es: {
        firstName: 'Nombre',
        lastName: 'Apellido',
        middleNameInitial: 'Segundo nombre',
        title: 'Título',
        titles: [
            {
                'display_name': 'Sr.',
                'value': 'Mr.',
            },
            {
                'display_name': 'Srta.',
                'value': 'Miss',
            },
            {
                'display_name': 'Sra.',
                'value': 'Mrs.',
            },
            {
                'display_name': 'Sra.',
                'value': 'Ms.',
            },
            {
                'display_name': 'Dr.',
                'value': 'Dr.',
            },
        ],
        suffix: 'Sufijo',
        suffixes: [
            {
                'display_name': 'H',
                'value': 'Jr.',
            },
            {
                'display_name': 'P',
                'value': 'Sr.',
            },
            {
                'display_name': 'III',
                'value': 'III',
            },
            {
                'display_name': 'IV',
                'value': 'IV',
            },
            {
                'display_name': 'V',
                'value': 'V',
            },
            {
                'display_name': 'Esq.',
                'value': 'Esq.',
            },
            {
                'display_name': 'Ph.D',
                'value': 'Ph.D',
            },
        ],
        dateOfBirth: 'Fecha de nacimiento',
        phoneNumber: 'Número de teléfono',
        emailAddress: 'Correo electrónico',
        addressType: 'Tipo de dirección',
        address_types: [
            {
                'display_name': 'Residencial',
                'value': 'home',
            },
            {
                'display_name': 'Postal',
                'value': 'mailing',
            },
            {
                'display_name': 'Laboral',
                'value': 'work',
            },
            {
                'display_name': 'No sabe',
                'value': 'unknown',
            },
        ],
        addressLine1: 'Dirección 1',
        addressLine2: 'Dirección 2',
        addressCity: 'Ciudad',
        state: 'Estado',
        addressZip: 'Código postal',
        citizenship: 'Ciudadanía',
        citizenships: [
            {
                'display_name': 'Ciudadano estadounidense',
                'value': 'us-citizen',
            },
            {
                'display_name': 'Nacionalidad estadounidense',
                'value': 'us-national',
            },
            {
                'display_name': 'Residente legal permanente',
                'value': 'lawful-permanent-resident',
            },
            {
                'display_name': 'Otro',
                'value': 'other',
            },
            {
                'display_name': 'Prefiero no responder',
                'value': 'undisclosed',
            },
        ],
        gender: 'Sexo',
        genders: [
            {
                'display_name': 'Masculino',
                'value': 'male',
            },
            {
                'display_name': 'Femenino',
                'value': 'female',
            },
            {
                'display_name': 'Prefiero no responder',
                'value': 'undisclosed',
            },
            {
                'display_name': 'Otro',
                'value': 'other',
            },
        ],
        maritalStatus: 'Estado civil',
        maritalStatuses: [
            {
                'display_name': 'Divorciado',
                'value': 'divorced',
            },
            {
                'display_name': 'En pareja de hecho',
                'value': 'domestic_partner',
            },
            {
                'display_name': 'Casado/unión civil',
                'value': 'married-civil-union',
            },
            {
                'display_name': 'Soltero/nunca casado',
                'value': 'single/never-married',
            },
            {
                'display_name': 'Separado',
                'value': 'separated',
            },
            {
                'display_name': 'Prefiero no responder',
                'value': 'undisclosed',
            },
            {
                'display_name': 'Viudo',
                'value': 'widowed',
            },
        ],
        race: 'Raza',
        races: [
            {
                'display_name': 'Indio americano/nativo de Alaska',
                'value': 'american-indian-alaska-native',
            },
            {
                'display_name': 'Asiático',
                'value': 'asian',
            },
            {
                'display_name': 'Afroamericano/negro',
                'value': 'black-african-american',
            },
            {
                'display_name': 'Nativo de Hawái o de islas del Pacífico',
                'value': 'native-hawaiian-or-pacific-islander',
            },
            {
                'display_name': 'Otra raza',
                'value': 'other-race',
            },
            {
                'display_name': 'Prefiero no responder',
                'value': 'undisclosed',
            },
            {
                'display_name': 'Blanco',
                'value': 'white',
            },
        ],
        ethnicity: 'Origen étnico',
        ethnicities: [
            {
                'display_name': 'Latino o hispano',
                'value': 'hispanic-or-latino',
            },
            {
                'display_name': 'Ni latino ni hispano',
                'value': 'not-hispanic-or-latino',
            },
            {
                'display_name': 'Prefiero no responder',
                'value': 'undisclosed',
            },
        ],
        householdGrossMonthlyIncome: 'Ingreso mensual bruto',
        servicesSeeking: '¿Que servicios necesita?',
        describeRequest: 'DESCRIBA SU SOLICITUD DE SERVICIOS',
        pleaseSignPre: 'Firme en la casilla a continuación para dar su ',
        pleaseSignConsent: 'consentimiento',
        pleaseSignPost: 'para recibir servicios',
        clearSignature: 'borrar firma',
        submit: 'Enviar',
        submitting: 'Sumisión...',
        failedSubmission: 'El formulario no se pudo enviar. Por favor envíe de nuevo.',
        signatureRequired: 'Se requiere la firma de consentimiento',
        required: 'Requerido',
        // military: {
        //     militaryAffiliation: 'Military Affiliation',
        //     currentStatus: 'Current Status',
        //     currentlyTransitioning: 'Currently Transitioning?',
        //     atLeastoneDayActiveDuty: 'Has at least one day of active duty outside of basic training?', //enum
        //     branch: 'Branch of Service', //enum
        //     serviceEra: 'ServiceArea', //enum
        //     entryDate: 'Entry Date',
        //     exitDate: 'Exit Date',
        //     deployed: 'Deployed',
        //     deploymentStartsAt: 'Deployment Dates',
        //     //deploymentEndsAt: ''
        //     //enums
        //     dischargedDueToDisability: 'Discharged or retired from military service for a disability incurred in the line of duty?',
        //     //enum
        //     serviceConnectedDisability: 'Has VA-rated Service-Connected Disability?',
        //     //enum
        //     serviceConnectedDisabilityRating: 'Service-Connected Disability Rating',
        //     //enum
        //     proofOfVeteranStatus: 'Proof of veteran status?',
        //     //enum
        //     proofType: 'Proof Type'
        // },
        consent : {
            title: 'Consentimiento para participar en la Red Unite Us',
            consentParagraph1: 'Al dar su consentimiento, usted acepta compartir información con una Red de socios de servicios sociales y de salud impulsada por el software Unite Us. Esta Red está compuesta por entidades y personas que participan directamente en su atención o en el pago de su atención. Su información personal puede ser compartida de forma segura en la Red de acuerdo con las leyes de privacidad para conectarlo con los servicios.',
            consentParagraph2: 'Este consentimiento cubre toda la información compartida por usted o por cualquier persona que tenga derecho a compartir información en su nombre y sea relevante para la participación del beneficiario en su atención o en el pago de su atención. Usted siempre puede limitar la información que proporciona en la Red solicitando que se elimine.',
            consentParagraph3: 'Para entender cómo se puede usar su información y mantenerla segura en la Red, consulte uniteus.com/privacy.',
            consentParagraph4: 'Si ya no desea que su información se comparta en la Red, puede enviar un correo electrónico a consent@uniteus.com o solicitarlo a cualquier socio de la Red.'

        },
        success: {
            success: '¡Correcto!',
            thankYou: 'Gracias por enviar la solicitud. Estamos revisando la solicitud y esperamos comunicarnos con los servicios que necesita.',
            downloadConsent: 'Descargue el formulario de consentimiento firmado'
        }
    },
    ht: {
        firstName: 'Non',
        lastName: 'Siyati',
        middleNameInitial: 'Dezyèm Non',
        title: 'Tit',
        titles: [
            {
                'display_name': 'Mesye.',
                'value': 'Mr.',
            },
            {
                'display_name': 'Madmwazèl',
                'value': 'Miss',
            },
            {
                'display_name': 'Madam',
                'value': 'Mrs.',
            },
            {
                'display_name': 'Madam',
                'value': 'Ms.',
            },
            {
                'display_name': 'Doktè',
                'value': 'Dr.',
            },
        ],
        suffix: 'Sifiks',
        suffixes: [
            {
                'display_name': 'Jr.',
                'value': 'Jr.',
            },
            {
                'display_name': 'Sr.',
                'value': 'Sr.',
            },
            {
                'display_name': 'III',
                'value': 'III',
            },
            {
                'display_name': 'IV',
                'value': 'IV',
            },
            {
                'display_name': 'V',
                'value': 'V',
            },
            {
                'display_name': 'Esq.',
                'value': 'Esq.',
            },
            {
                'display_name': 'Ph.D',
                'value': 'Ph.D',
            },
        ],
        dateOfBirth: 'Dat Nesans',
        phoneNumber: 'Nimewo Telefòn',
        emailAddress: 'Imèl',
        addressType: 'Ki tip adrès',
        address_types: [
            {
                'display_name': 'Adomisil',
                'value': 'home',
            },
            {
                'display_name': 'Lapòs',
                'value': 'mailing',
            },
            {
                'display_name': 'Travay',
                'value': 'work',
            },
            {
                'display_name': 'Enkoni',
                'value': 'unknown',
            },
        ],
        addressLine1: 'Adrès Liy 1',
        addressLine2: 'Adrès Liy 2',
        addressCity: 'Vil',
        state: 'Eta',
        addressZip: 'Kòd Postal',
        citizenship: 'Sitwayènte',
        citizenships: [
            {
                'display_name': 'Sitwayen Ameriken',
                'value': 'us-citizen',
            },
            {
                'display_name': 'Nasyonal Ameriken',
                'value': 'us-national',
            },
            {
                'display_name': 'Rezidan Pèmanan Lejitim',
                'value': 'lawful-permanent-resident',
            },
            {
                'display_name': 'Lòt',
                'value': 'other',
            },
            {
                'display_name': 'Ki Pa Pibliye',
                'value': 'undisclosed',
            },
        ],
        gender: 'Sèks',
        genders: [
            {
                'display_name': 'Gason',
                'value': 'male',
            },
            {
                'display_name': 'Fi',
                'value': 'female',
            },
            {
                'display_name': 'Pito pa di',
                'value': 'undisclosed',
            },
            {
                'display_name': 'Lòt',
                'value': 'other',
            },
        ],
        maritalStatus: 'Eta Sivil',
        maritalStatuses: [
            {
                'display_name': 'Divòse',
                'value': 'divorced',
            },
            {
                'display_name': 'Patnè ki nan Kay',
                'value': 'domestic_partner',
            },
            {
                'display_name': 'Marye/Maryaj Sivil',
                'value': 'married-civil-union',
            },
            {
                'display_name': 'Selibatè/Pa Janm Marye',
                'value': 'single/never-married',
            },
            {
                'display_name': 'Separe',
                'value': 'separated',
            },
            {
                'display_name': 'Ki pa Pibliye',
                'value': 'undisclosed',
            },
            {
                'display_name': 'Vèv/Vèf',
                'value': 'widowed',
            },
        ],
        race: 'Ras',
        races: [
            {
                'display_name': 'Endyen Ameriken oswa Natif Natal Alaska',
                'value': 'american-indian-alaska-native',
            },
            {
                'display_name': 'Azyatik',
                'value': 'asian',
            },
            {
                'display_name': 'Nwa/Afriken Ameriken',
                'value': 'black-african-american',
            },
            {
                'display_name': 'Natif Natal Awayen oswa Moun sou Zile Pasifik',
                'value': 'native-hawaiian-or-pacific-islander',
            },
            {
                'display_name': 'Lòt Ras',
                'value': 'other-race',
            },
            {
                'display_name': 'Ki pa Pibliye',
                'value': 'undisclosed',
            },
            {
                'display_name': 'Blan',
                'value': 'white',
            },
        ],
        ethnicity: 'Etnisite',
        ethnicities: [
            {
                'display_name': 'Ispanik oswa Latino',
                'value': 'hispanic-or-latino',
            },
            {
                'display_name': 'Ki Pa Ispanik oswa Latino',
                'value': 'not-hispanic-or-latino',
            },
            {
                'display_name': 'Ki pa Pibliye',
                'value': 'undisclosed',
            },
        ],
        householdGrossMonthlyIncome: 'Revni Brit Chak Mwa',
        servicesSeeking: 'KI SÈVIS W AP CHÈCHE?',
        describeRequest: 'TANPRI DEKRI SÈVIS W AP MANDE YO',
        pleaseSignPre: 'Tanpri siyen nan kaz ki anba a pou bay',
        pleaseSignConsent: 'konsantman',
        pleaseSignPost: 'w pou resevwa sèvis yo',
        clearSignature: 'Siyati klè',
        submit: 'Soumèt',
        submitting: 'Soumèt...',
        failedSubmission: 'Fòm nan pa t soumèt. Tanpri soumèt ankò.',
        signatureRequired: 'Siyati konsantman an obligatwa',
        required: 'Obligatwa',
        // military: {
        //     militaryAffiliation: 'Military Affiliation',
        //     currentStatus: 'Current Status',
        //     currentlyTransitioning: 'Currently Transitioning?',
        //     atLeastoneDayActiveDuty: 'Has at least one day of active duty outside of basic training?', //enum
        //     branch: 'Branch of Service', //enum
        //     serviceEra: 'ServiceArea', //enum
        //     entryDate: 'Entry Date',
        //     exitDate: 'Exit Date',
        //     deployed: 'Deployed',
        //     deploymentStartsAt: 'Deployment Dates',
        //     //deploymentEndsAt: ''
        //     //enums
        //     dischargedDueToDisability: 'Discharged or retired from military service for a disability incurred in the line of duty?',
        //     //enum
        //     serviceConnectedDisability: 'Has VA-rated Service-Connected Disability?',
        //     //enum
        //     serviceConnectedDisabilityRating: 'Service-Connected Disability Rating',
        //     //enum
        //     proofOfVeteranStatus: 'Proof of veteran status?',
        //     //enum
        //     proofType: 'Proof Type'
        // },
        consent : {
            title: 'Konsantman pou Patisipe nan Rezo Unite Us la',
            consentParagraph1: 'Depi ou bay konsantman ou, sa vle di ou dakò pou pataje enfòmasyon ak yon Rezo patnè sèvis sante y ap jere ak lojisyèl Unite Us (Ini Nou). Rezo sa a fèt ak plizyè antite k moun ki enplike dirèkteman nan swen ou. Ou ka pataje enfòmasyon pèsonèl ou yon fason sekirize nan rezo a konfòmeman avèk lwa sou vi prive pou konekte ou ak sèvis yo.',
            consentParagraph2: 'Konsantman sa a kouvri tout enfòmasyon ou menm ou pataje oswa nenpòt moun ki gen dwa pou pataje enfòmasyon pou ou epi ki gen rapò ak patisipasyon benefisyè a nan swen ou oswa peman pou swen ou. Ou ka toujou limite enfòmasyon ou bay sou Rezo a lè ou mande pou yo retire li.',
            consentParagraph3: 'Pou konprann ki jan enfòmasyon ou ka itilize ak rete an sekirite sou Rezo a, tanpri al gade uniteus.com/privacy.',
            consentParagraph4: 'Si ou pa vle nou pataje enfòmasyon ou nan Rezo a, ou ka imèl consent@uniteus.com oswa mande nenpòt patnè Rezo.'

        },
        success: {
            success: 'Siksè!',
            thankYou: 'Mèsi paske w soumèt demann ou a. N ap egzamine demann ou a, epi nou pa ka tann pou n mete w an kontak ak sèvis ou bezwen an.',
            downloadConsent: 'Telechaje Fòm Konsantman ki Siyen Ou nan '
        }
    }
}

// "<h3>Consent to Participate in the Unite Us Network</h3>
// <p>By consenting, you agree to share information with a Network of health and social service partners powered by Unite Us software. This network is made up of entities and individuals who are directly involved in your care or payment of care. Your personal information may be shared securely on the Network in accordance with privacy laws to connect you with services.</p>
// <p>This consent covers all information shared by you or by anyone that has the right to share information on your behalf and is relevant to the recipient's involvement in your care or payment for your care. You can always limit the information you provide on the Network by requesting to have it removed.</p>
// <p>To understand how your information may be used and kept safe on the Network, please see <a href="https://www.uniteus.com/privacy" target="_blank" rel="noopener noreferrer">uniteus.com/privacy</a>.</p>
// <p>If you no longer want your information shared on the Network, you can email <a href="mailto:consent@uniteus.com" target="_blank" rel="noopener noreferrer">consent@uniteus.com</a> or ask any Network partner.</p>
//"
